/**
 * InfinitSales - abre a sessão do CRM embutido (white label, 2026-10-22).
 *
 * Usado pela rota /embed (primeira carga) e pelo EmbedListener (sessão que
 * caiu ou conta que trocou). Grava o estado do modo embutido, valida o token
 * no backend (GET /users/me) e recarrega a aba na tela pedida, para o
 * AuthContext e o tema nascerem já com a sessão e a marca.
 */
import authService from './authService';
import { routeForScreen, setEmbedState } from '../../utils/embed';

export async function establishEmbedSession(sessao, destinoAtual = null) {
  const anterior = authService.getStoredUser();
  if (anterior && anterior.id !== sessao.payload.user_id) {
    // Outra conta nesta aba: nada do cache da anterior pode sobrar.
    authService.logout();
  }
  setEmbedState({
    origin: sessao.origin,
    userId: sessao.payload.user_id,
    branding: sessao.branding,
  });
  localStorage.setItem('token', sessao.token);
  const response = await authService.getProfile();
  authService.storeAuthData(response.data, sessao.token);
  if (sessao.openChat) {
    try {
      sessionStorage.setItem('pendingOpenChat', JSON.stringify(sessao.openChat));
    } catch {
      /* storage indisponível: abre a lista sem a conversa */
    }
  }
  const destino = routeForScreen(sessao.screen) || destinoAtual || '/funis';
  window.location.replace(destino);
}
